import React from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import { TransferDetailsFields, TransferForm } from '@Types'
import { useFormatNumber } from '../../utils/intlHelpers'
import isNil from 'lodash.isnil'

export interface Props {
  fields?: TransferForm
  cashDirection?: string
}

export const BasicTransferDetails = ({ fields, cashDirection }: Props) => {
  const formatNumber = useFormatNumber()
  const transferDetails = fields?.transferDetails as TransferDetailsFields
  const transferAmount = formatNumber(transferDetails?.transferAmount?.raw as number, {
    style: 'currency',
    currency: 'USD'
  })

  return (
    <Stack spacing='8'>
      <Stack direction='row' spacing='5'>
        {transferDetails?.transferType?.raw && (
          <Box width={7.5 / 16}>
            <Text>Transfer Type</Text>
            <Text>{transferDetails.transferType.display}</Text>
          </Box>
        )}

        {(!isNil(transferDetails?.transferAmount?.raw) || transferDetails?.totalAccountBalance?.checked) && (
          <Box width={7.5 / 16}>
            <Text>{cashDirection || 'Transfer'} Amount</Text>
            <Text>{transferDetails?.totalAccountBalance?.checked ? 'Total Balance' : transferAmount}</Text>
          </Box>
        )}
      </Stack>

      {transferDetails?.accounts?.from?.display && (
        <Stack direction='row' spacing='5'>
          <Box width={7.5 / 16}>
            <Text>From Account</Text>
            <Text>{transferDetails.accounts.from.display}</Text>
          </Box>
        </Stack>
      )}

      {transferDetails?.accounts?.to?.display && (
        <Stack direction='row' spacing='5'>
          <Box width={7.5 / 16}>
            <Text>To Account</Text>
            <Text>{transferDetails.accounts.to.display}</Text>
          </Box>
        </Stack>
      )}

      {transferDetails?.transferType.raw === 'CASH JOURNAL Journal' && (
        <>
          <Stack direction='row' spacing='5'>
            <Box width={7.5 / 16}>
              <Text>From Account</Text>
              <Text>{transferDetails.accounts.from}</Text>
            </Box>
          </Stack>
          <Stack>
            <Box width={7.5 / 16}>
              <Text>To Account</Text>
              <Text>{transferDetails.accounts.to}</Text>
            </Box>
          </Stack>
        </>
      )}

      {fields?.transferDate && (
        <Stack direction='row' spacing='5'>
          <Box width={7.5 / 16}>
            <Text>Transfer Date</Text>
            <Text>{fields?.transferDate}</Text>
          </Box>
        </Stack>
      )}
    </Stack>
  )
}
